import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { DELETIONS, ORDERS } = API_ENDPOINTS;

// The deletion ledger — read-only record of everything the superadmin removed.
// There is deliberately no update/delete here: an audit you can edit is not
// an audit.
export const deletionsApi = {
  /** ?section=&q=&date_from=&date_to= */
  getList: (params = {}) => axiosInstance.get(DELETIONS.LIST, { params }),
};

// SUPERADMIN order delete — the most destructive action in the panel, so it
// carries the admin password. { password, reason?, section: 'orders'|'dispatch' }
export const deleteOrder = (inquiryId, data) =>
  axiosInstance.delete(ORDERS.DELETE(inquiryId), { data });
